import { html } from "../../../../"
import { SYSBaseElement } from "../../../sysbaseelement"
import type { SYSField } from "../../actions"
import { GetRowFromFormState, GetValueFromCustomFunction } from "../helpers"

export class SYSCustomValueHint extends SYSBaseElement {
  field: SYSField
  props: any

  async getUI() {
    let customValue
    this.field = this.props()
    this.field._state.visible
    let field = this.field
    if (
      field.hasFocus &&
      field.touched &&
      !field.ui.displayValueHintWhileTyping
    ) {
      return
    }
    let align = ""
    if (field.ui?.align) {
      align = field.ui.align
    }
    let formState = this.state.ovl.forms[field.formType][field.formId]
    if (!formState) {
      return null
    }

    customValue = GetValueFromCustomFunction(
      GetRowFromFormState(formState),
      field,
      formState,
      align,
      this.state
    )
    if (!customValue || customValue.length === 0) {
      return
    }
    // } else {
    //   return html`<div></div>`
    // }

    return html`
      <div
        class=${`fadeInControlHint fd-form-message  ovl-formcontrol-custom ovl-formcontrol-listcontrol-custom ovl-formcontrol-custom__${field.fieldKey}`}
      >
        ${customValue}
      </div>
    `
  }
}
